import { AuthService, type RegisterBodyDto } from 'app/API';
import type { TCall } from 'app/queries/types/TCall';

type TParams = {
  call: TCall;
  requestBody: RegisterBodyDto;
  onError: (message: string) => void;
};

export const register = ({ call, requestBody, onError }: TParams) =>
  call(() => AuthService.register({ requestBody }), { onError });
